export default __webpack_public_path__ + "static/media/logistic.ed25a8e5.png";